module.exports = __webpack_public_path__ + "f023cebeb4dffbdc1951f33b421dbd80.pdf";